var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plan", class: { selected: _vm.selected } },
    [
      _c("div", { staticClass: "header" }, [_vm._v("Whatsapp Plus")]),
      _vm._v(" "),
      _c("div", { staticClass: "plan-price-section" }, [
        _c("div", { staticClass: "plan-price-details" }, [
          _c(
            "span",
            {
              staticClass: "amount",
              class: { tl: _vm.site.basePrice.currency === "tl" },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$_.get(
                    _vm.site,
                    "whatsappPlusBasePrice.value",
                    _vm.DEFAULT_PRICING.PLUS.tl.price
                  )
                )
              ),
            ]
          ),
          _vm._v(" "),
          _c("i", [
            _c("i", { staticClass: "slash" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("i", { staticClass: "billed-month" }, [
              _vm._v(
                _vm._s(_vm.$t("billing.month")) + "\n                    "
              ),
              _c("i", { staticClass: "billed-yearly hide" }, [
                _c("br"),
                _vm._v(_vm._s(_vm.$t("billing.billedMonthToMonth"))),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "md-raised md-primary w-100",
          staticStyle: {
            transform: "scale(0.7)",
            "font-size": "x-large",
            "border-radius": "10%",
          },
          attrs: { disabled: _vm.selected },
          on: { click: _vm.onSelected },
        },
        [
          _vm._v(
            _vm._s(_vm.$t(_vm.selected ? "wp.subscribed" : "wp.subscribe")) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "text-succes" }, [_vm._v("-")]),
      _vm._v(" "),
      _c("a-divider", [_vm._v(_vm._s(_vm.$t("wp.planDetails")))]),
      _vm._v(" "),
      _c("div", { staticClass: "features" }, [
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.includesAllBasicPlans")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", { staticClass: "text-success" }, [
              _vm._v(_vm._s(_vm.$t("wp.chatbotIntegration"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", { staticClass: "text-success" }, [
              _vm._v(_vm._s(_vm.$t("wp.messageToNewNumbers"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", { staticClass: "text-success" }, [
              _vm._v(_vm._s(_vm.$t("wp.broadcastMessageToEveryone"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", { staticClass: "text-success" }, [
              _vm._v(_vm._s(_vm.$t("wp.personalizedBroadcastMessage"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("wp.customerGroupSegmentation"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.scheduleBroadcastMessage")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [
              _vm._v("Buttons Message Support (Chatbot & Broadcast)"),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [
              _vm._v("Gallery Message Support (Chatbot & Broadcast)"),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "Quick Reply Button Message Support (Chatbot & Broadcast)"
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.locationMessageSupport")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.advancedSpamPreventions")))]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }